import React from 'react';
import AWSUI from '@amzn/awsui-components-react';
import { isEmpty } from 'lodash';
import { getAutoSyncResourcesField, getDisablePlaybackSkill } from '../uiUtils';
import AppConstants from '../../../_Constants/AppConstants';
import GeneralAcousticTestTypeSelection from './GeneralAcousticTestTypeSelection';
import FARCustomSubpage from '../FARCustomSubscenarioSelection';
import WakewordTestTypeSelection from "../Wakeword/WakewordTestTypeSelection";

class Acoustic extends React.Component {

  getCheckboxOptionsForAcoustic = (selectedScenario, selectedScenarioCallBack, lockFields) => {
    return (
      <AWSUI.ColumnLayout columns={2} borders='vertical'>
        <div data-awsui-column-layout-root='true'>
          {getAutoSyncResourcesField(selectedScenario.isAutoSyncEnabled,
              selectedScenario, selectedScenarioCallBack, lockFields)}
          {
            [AppConstants.FARFIELD, AppConstants.NEARFIELD].some((element) => element === selectedScenario.scenarioType) &&
            getDisablePlaybackSkill(selectedScenario, selectedScenarioCallBack)
          }
        </div>
      </AWSUI.ColumnLayout>
    )
  }

  render() {
    const { selectedScenario, selectedScenarioCallBack,
      selectedScenarioError, scenarioErrorCallBack,
      otherParams, updateOtherParamsCallBack,
      whitelistedCustomerIds, primaryDSNSelected,
      dutsInUse, updateNewRunStateParameterCallBack,
      lockFields } = this.props.params;
    return (
      <div>
        {this.getCheckboxOptionsForAcoustic(selectedScenario, selectedScenarioCallBack, lockFields)}
        { selectedScenario.scenarioType === AppConstants.NEARFIELD &&
          <GeneralAcousticTestTypeSelection params={{
            selectedScenario: selectedScenario,
            selectedScenarioCallBack: selectedScenarioCallBack,
            selectedScenarioError: selectedScenarioError,
            scenarioErrorCallBack: scenarioErrorCallBack,
            piLocations: AppConstants.nearFieldLocation,
          }} />
        }
        { selectedScenario.scenarioType === AppConstants.WAKEWORD &&
         <WakewordTestTypeSelection params= {{
           selectedScenario: selectedScenario,
           selectedScenarioCallBack: selectedScenarioCallBack,
           selectedScenarioError: selectedScenarioError,
           scenarioErrorCallBack: scenarioErrorCallBack,
         }} />}
        { selectedScenario.scenarioType === AppConstants.FARFIELD &&
          <GeneralAcousticTestTypeSelection params={{
            selectedScenario: selectedScenario,
            selectedScenarioCallBack: selectedScenarioCallBack,
            selectedScenarioError: selectedScenarioError,
            scenarioErrorCallBack: scenarioErrorCallBack,
            piLocations: AppConstants.farFieldLocation,
          }} />
        }
        { selectedScenario.scenarioType === AppConstants.FAR_CUSTOM &&
          <FARCustomSubpage params={{
            selectedScenario: selectedScenario,
            selectedScenarioCallBack: selectedScenarioCallBack,
            selectedScenarioError: selectedScenarioError,
            scenarioErrorCallBack: scenarioErrorCallBack,
            otherParams: otherParams, // TODO: only pass deviceMapping there
            updateOtherParamsCallBack: updateOtherParamsCallBack,
            whitelistedCustomerIds: whitelistedCustomerIds,
            dutsInUse: dutsInUse,
            updateNewRunStateParameterCallBack: updateNewRunStateParameterCallBack,
            primaryDSNSelected: primaryDSNSelected,
          }} />
        }
      </div>
    )
  }
}

export default Acoustic;
